<template lang="pug">
  .board-controller
    p.waiting(v-if="!minimumPlayersLoggedIn") Waiting for players
    button(v-else-if='!board', @click='startGame') Start game

    .board(v-if='board')
      p.round-no Round no. {{ currentRoundNumber }}

      .current-black-card-container(v-if='currentBlackCard')
        black-card(:card='currentBlackCard', :picks='currentRoundWinner && currentRoundWinner.whiteCards')

      .current-white-cards-container(v-if='currentPlayedWhiteCards && enoughWhiteCardsPlayed')
        .cards(
          v-for='(cards, key) in currentPlayedWhiteCards',
          :class='{active: currentRoundWinner && Object.values(currentRoundWinner.whiteCards)[0].index === Object.values(cards)[0].index}',
          :style='`order: ${cards[0].index}`'
        )
          white-card(v-for='card in cards', :card='card', :key='card.index')
          .winner(v-if='currentRoundWinner') {{ players[key].name }}

    // pre(v-if='leadingPlayerID') leading: {{ players[leadingPlayerID].name }} {{leadingPlayerID }}
    // pre(v-if='board && currentRoundWinner') current round winner: {{ currentRoundWinner }}
    .game-over(v-if='gameOver')
      p GAME OVER!
      p winner:

    button.reset(@click="resetGame") RESET GAME
</template>

<script>
  import { db } from '@/db'
  import BlackCard from '@/components/BlackCard'
  import WhiteCard from '@/components/WhiteCard'

  export default {
    name: 'BoardController',
    components: { WhiteCard, BlackCard },
    data() {
      return {
        allCards: {},
        game: {},
        currentRoundKey: null,
        gameOver: false,

        rules: {
          minimumPlayers: 3,
          initialHandSize: 10,
        }
      }
    },
    firebase: {
      game: db.ref('game'),
      allCards: db.ref('allCards'),
    },
    computed: {
      players () {
        return this.game.players
      },
      minimumPlayersLoggedIn() {
        return this.players && Object.keys(this.players).length >= this.rules.minimumPlayers
      },
      availableWhiteCardsNumber () {
        return this.game.whiteCards.filter(i => i !== undefined).length - 1
      },
      availableBlackCards () {
        return this.game.blackCards.filter(i => i !== undefined)
      },
      board () {
        return this.game.board
      },
      currentBlackCard () {
        return this.board && this.board.currentBlackCard
      },
      currentPlayedWhiteCards () {
        return this.board && this.board.currentPlayedWhiteCards ?
          this.board.currentPlayedWhiteCards:
          // Object.values(this.board.currentPlayedWhiteCards).sort(() => .5 - Math.random()) :
          null
      },
      enoughWhiteCardsPlayed () {
        return this.currentPlayedWhiteCards ?
          Object.keys(this.currentPlayedWhiteCards).length === Object.keys(this.players).length - 1 // -1 to account for czar
          : null
      },
      currentRoundNumber () {
        const rounds = this.game.rounds
        if (!rounds) return 0
        let largest = 0
        for (const id in rounds) {
          if (rounds.hasOwnProperty(id)) {
            console.log(rounds[id])
            largest = rounds[id].number > largest ? rounds[id].number : largest
          }
        }
        return largest
        // return Object.keys(rounds).reduce((a, b) =>
        //   rounds[a].number > rounds[b].number ? rounds[a] : rounds[b])
      },
      currentRound () {
        return this.currentRoundKey && this.game.rounds[this.currentRoundKey]
      },
      currentRoundWinner () {
        return this.currentRound && this.currentRound.winner
      },
      nextRoundRequested () {
        return this.game.nextRoundRequested
      },
      newGameRequested () {
        return this.game.newGameRequested
      },
      scores () {
        const rounds = this.game.rounds
        if (!rounds) return false
        const roundPlayerIDs = Object.values(rounds).map(r => r.winner && r.winner.player)
        let scores = {}
        roundPlayerIDs.forEach(id => {
          if (id !== undefined) {
            scores[id] = scores.hasOwnProperty(id) ? scores[id] + 1 : 1
          }
        })
        return scores
      },
      leadingPlayerID () {
        const scores = this.scores
        const max = Math.max(...Object.values(scores))
        const maxIndex = Object.values(scores).findIndex(s => s === max)
        const maxID = Object.keys(scores)[maxIndex]
        return maxID
        // todo resolve tie
      }
    },
    methods: {
      async dealWhiteCardToPlayer (playerID) {
        // get random card index from available cards
        const cardIndex = Math.floor(Math.random() * this.availableWhiteCardsNumber)
        console.log(cardIndex)
        // put card in hand
        await db.ref('game/players').child(playerID).child('hand').child(cardIndex).set({text: this.game.whiteCards[cardIndex], index: cardIndex})
        // remove card from pile
        await db.ref('game/whiteCards').child(cardIndex).remove()
      },

      drawBlackCard () {
        // get random card index from available cards
        const cardIndex = Math.floor(Math.random() * this.availableBlackCards.length - 1)
        // put card on board
        db.ref('game/board').child('currentBlackCard').set({text: this.game.blackCards[cardIndex].text, pick: this.game.blackCards[cardIndex].pick, index: cardIndex})
        // remove card from pile
        db.ref('game/blackCards').child(cardIndex).remove()
      },

      setCurrentRound () {
        db.ref('game')
          .child('rounds')
          .push({number: this.currentRoundNumber + 1})
          .then(id => {
            this.currentRoundKey = id.key

            db.ref('game')
              .child('currentRoundKey')
              .set(this.currentRoundKey)
          })
      },

      dealAllPlayersWhiteCards (num) {
        // for each player
        for (const playerID in this.players) {
          // loop on num
          for (let i of Array(num).keys()) {
            // deal card
            this.dealWhiteCardToPlayer(playerID)
          }
        }
      },

      setCzar () {
        const getNextCzar = () => {
          let playersList = Object.values(this.players)
          console.log(playersList[0]['.key'])
          if (!this.game.currentCzar)
            return Object.keys(this.players)[Math.floor(Math.random() * (playersList.length))]

          const currentIndex = Object.keys(this.players).findIndex(key => key === this.game.currentCzar)
          return currentIndex === playersList.length - 1
            ? Object.keys(this.players)[0]
            : Object.keys(this.players)[currentIndex + 1]
        }

        db.ref('game').child('currentCzar').set(getNextCzar())
      },

      clearPlayedWhiteCards () {
        db.ref('game/board').child('currentPlayedWhiteCards').set({})
        db.ref('game/board').child('enoughWhiteCardsPlayed').set(false)
      },

      startNewRound (initial = false) {
        if (this.availableWhiteCardsNumber === -1 || !this.availableBlackCards.length) {
          this.endGame()
          return
        }

        const cardsNum = initial ? this.rules.initialHandSize : this.currentBlackCard.pick

        this.dealAllPlayersWhiteCards(cardsNum)
        if (!initial) this.clearPlayedWhiteCards()
        this.drawBlackCard()
        this.setCurrentRound()
        this.setCzar()
        if (!initial) db.ref('game').child('nextRoundRequested').set(false)
      },

      startGame () {
        this.startNewRound(true)
        db.ref('game').child('canStartGame').remove()
      },

      endGame () {
        this.gameOver = true
      },

      resetGame () {
        db.ref('game').remove()
        this.$router.go()
      }
    },
    watch: {
      allCards (allCards) {
        console.log('all cards loaded, pushing to game')
        db.ref('game').child('whiteCards').set(allCards.whiteCards)
        db.ref('game').child('blackCards').set(allCards.blackCards)
      },
      minimumPlayersLoggedIn (newValue, oldValue) {
        if (!oldValue && newValue) { // only run on first time
          console.log('all players in, dealing initial hands')
          db.ref('game').child('canStartGame').set({true: true})
          // this.startNewRound(true)
        }
      },
      enoughWhiteCardsPlayed (value) {
        if (value !== null)
          db.ref('game/board').child('enoughWhiteCardsPlayed').set(value)
      },
      nextRoundRequested (val) {
        if (val) {
          this.startNewRound()
        }
      },
      newGameRequested (val) {
        if (val) {
          db.ref('game').child('newGameRequested').remove()
          this.startGame()
        }
      }
    },
    mounted() {

    }
  }
</script>

<style scoped lang="sass">
  @import ../assets/css/var

  .board-controller
    max-width: 1024rem
    margin: 17% auto 0


  .cards.active
    border: solid 2rem $blue
    border-radius: $radius

  .current-white-cards-container
    display: flex
    align-items: flex-start
    margin-top: 3em

    > *
      flex: 1
      margin: $margin / 2
      position: relative

    .card + .card
      margin-top: 4rem

    .winner
      position: absolute
      color: $blue
      left: $margin
      width: 100%
      top: -2em

  .round-no
    margin-bottom: $margin
    text-align: center

  .waiting
    text-align: center

  .reset
    position: absolute
    bottom: $margin * 3
    width: 200rem
    left: calc(50% - 100rem)
</style>
